import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  dangerousGoods: {
    id: 'XpoKeo',
    defaultMessage: 'Dangerous Goods',
    description: 'Dangerous Goods tag',
  },
});
